import * as React from 'react';

import { Table } from 'reactstrap';

class RecapReportTests extends React.Component {
    public props: any;

    public state = {
        oilTests: [],
        waterTests: [],
        wellTests: this.props.wellTests
    };

    constructor(props: any) {
        super(props);
    }

    public componentDidMount() {
        this.getDifferentTests();
    }

    public componentWillReceiveProps(nextProps: any) {
        this.setState({
            wellTests: nextProps.wellTests
        });
    }

    private getDifferentTests() {
        const oilTests: any = [];
        const waterTests: any = [];
        if (this.state.wellTests[0]) {
            this.state.wellTests.map((test: any, index: number) => {
                if (test.fluidType === 'Oil Based Mud') {
                    oilTests.push(test);
                } else {
                    waterTests.push(test);
                }
            });
        }
        this.setState({
            oilTests,
            waterTests
        });
    }

    public render() {
        return(
            <div className="RecapReportTests">
                { this.state.waterTests.length > 0 &&
                    <React.Fragment>
                        <h5>Water Based Mud Tests</h5>
                        <Table>
                            <tbody>
                                <tr>
                                    <td className="label" rowSpan={2}>Date</td>
                                    <td className="label" rowSpan={2}>Time</td>
                                    <td className="label" rowSpan={2}>Depth MD</td>
                                    <td className="label" rowSpan={2}>Depth TVD</td>
                                    <td className="label" rowSpan={2}>Mud Weight lb/gal</td>
                                    <td className="label" rowSpan={2}>Funnel Vis sec/qt</td>
                                    <td className="label" rowSpan={2}>PV</td>
                                    <td className="label" rowSpan={2}>YP</td>
                                    <td className="label" colSpan={4}>Gel Strengths</td>
                                    <td className="label" colSpan={4}>Filtration</td>
                                    <td className="label" colSpan={3}>Retort</td>
                                    <td className="label" rowSpan={2}>LGS %</td>
                                    <td className="label" rowSpan={2}>pH</td>
                                    <td className="label" rowSpan={2}>Pm</td>
                                    <td className="label" colSpan={7}>Filtrate Analysis</td>
                                    <td className="label" rowSpan={2}>Daily Diesel gl</td>
                                    <td className="label" colSpan={2}>Cost</td>
                                </tr>
                                <tr>
                                    <td className="label">10 Sec</td>
                                    <td className="label">10 Min</td>
                                    <td className="label">30 Min</td>
                                    <td className="label">6 RPM</td>
                                    <td className="label">API ml</td>
                                    <td className="label">Cake 32nd</td>
                                    <td className="label">HTHP @ °</td>
                                    <td className="label">Cake 32nd</td>
                                    <td className="label">Solid %</td>
                                    <td className="label">Oil %</td>
                                    <td className="label">Water %</td>
                                    <td className="label">Pf</td>
                                    <td className="label">Mf</td>
                                    <td className="label">Chlorides mg/L</td>
                                    <td className="label">Calcium mg/L</td>
                                    <td className="label">Total Hardness</td>
                                    <td className="label">Mag mg/L</td>
                                    <td className="label">Lime ppb</td>
                                    <td className="label">Daily</td>
                                    <td className="label">Cum</td>
                                </tr>
                                {this.state.waterTests.map((test: any, index: number) =>
                                        <React.Fragment key={index}>
                                            <tr>
                                                <td>{test.testDate.split(' ')[0]}</td>
                                                <td>{test.testDate.split(' ')[1]}</td>
                                                <td>{test.depthMD}</td>
                                                <td>{test.depthTVD}</td>
                                                <td>{test.mudWeight}</td>
                                                <td>{test.funnelViscosity}</td>
                                                <td>{test.plasticViscosity}</td>
                                                <td>{test.yeildPoint}</td>
                                                <td>{test.gelStrength10sec}</td>
                                                <td>{test.gelStrength10min}</td>
                                                <td>{test.gelStrength30min}</td>
                                                <td>{test.rpmDegF6}</td>
                                                <td>{test.filtrateApi}</td>
                                                <td>{test.cakeThicknessApi}</td>
                                                <td>{test.filtrateHthp}</td>
                                                <td>{test.cakeThicknessHthp}</td>
                                                <td>{test.retortContentSolids}</td>
                                                <td>{test.retortContentOil}</td>
                                                <td>{test.retortContentWater}</td>
                                                <td>{test.lowGravityPcnt}</td>
                                                <td>{test.pHReading}</td>
                                                <td>{test.mudAlkalinityPom}</td>
                                                <td>{test.FiltrateAlkalinityPf}</td>
                                                <td>{test.FiltrateAlkalinityMf}</td>
                                                <td>{test.chlorideMgL}</td>
                                                <td>{test.calcium}</td>
                                                <td>{test.totalHardness}</td>
                                                <td>{test.magnesium}</td>
                                                <td>{test.excessLime}</td>
                                                <td>{test.baseOilUsed}</td>
                                                <td>{test.dailyTotal}</td>
                                                <td>{test.cumulativeTotal}</td>
                                            </tr>
                                            {test.recapRemarks !== '' && test.recapRemarks !== null &&
                                                <tr>
                                                    <td colSpan={32} style={{'textAlign': 'left'}}>{test.recapRemarks}</td>
                                                </tr>
                                            }
                                        </React.Fragment>
                                    )
                                }
                            </tbody>
                        </Table>
                    </React.Fragment>
                }
                { this.state.oilTests.length > 0 &&
                    <React.Fragment>
                        <h5>Oil Based Mud Tests</h5>
                        <Table>
                            <tbody>
                                <tr>
                                    <td className="label" rowSpan={2}>Date</td>
                                    <td className="label" rowSpan={2}>Time</td>
                                    <td className="label" rowSpan={2}>Depth MD</td>
                                    <td className="label" rowSpan={2}>Depth TVD</td>
                                    <td className="label" rowSpan={2}>Mud Weight lb/gal</td>
                                    <td className="label" rowSpan={2}>Funnel Vis sec/qt</td>
                                    <td className="label" rowSpan={2}>PV</td>
                                    <td className="label" rowSpan={2}>YP</td>
                                    <td className="label" colSpan={4}>Gel Strengths</td>
                                    <td className="label" colSpan={4}>Filtration</td>
                                    <td className="label" colSpan={3}>Retort</td>
                                    <td className="label" rowSpan={2}>LGS %</td>
                                    <td className="label" colSpan={4}>Filtrate Analysis</td>
                                    <td className="label" colSpan={2}>Oil Emulsions</td>
                                    <td className="label" colSpan={2}>Cost</td>
                                </tr>
                                <tr>
                                    <td className="label">10 Sec</td>
                                    <td className="label">10 Min</td>
                                    <td className="label">30 Min</td>
                                    <td className="label">6 RPM</td>
                                    <td className="label">API ml</td>
                                    <td className="label">Cake 32nd</td>
                                    <td className="label">HTHP @ °</td>
                                    <td className="label">Cake 32nd</td>
                                    <td className="label">Solid %</td>
                                    <td className="label">Oil %</td>
                                    <td className="label">Water %</td>
                                    <td className="label">CaCl2 ppm</td>
                                    <td className="label">Whl Mud Chl ml</td>
                                    <td className="label">Versinate</td>
                                    <td className="label">Lime ppb</td>
                                    <td className="label">O/W Ratio</td>
                                    <td className="label">Elec Stbty Volts</td>
                                    <td className="label">Daily</td>
                                    <td className="label">Cum</td>
                                </tr>
                                {this.state.oilTests.map((test: any, index: number) =>
                                        <React.Fragment key={index}>
                                            <tr>
                                                <td>{test.testDate.split(' ')[0]}</td>
                                                <td>{test.testDate.split(' ')[1]}</td>
                                                <td>{test.depthMD}</td>
                                                <td>{test.depthTVD}</td>
                                                <td>{test.mudWeight}</td>
                                                <td>{test.funnelViscosity}</td>
                                                <td>{test.plasticViscosity}</td>
                                                <td>{test.yeildPoint}</td>
                                                <td>{test.gelStrength10sec}</td>
                                                <td>{test.gelStrength10min}</td>
                                                <td>{test.gelStrength30min}</td>
                                                <td>{test.rpmDegF6}</td>
                                                <td>{test.filtrateApi}</td>
                                                <td>{test.cakeThicknessApi}</td>
                                                <td>{test.filtrateHthp}</td>
                                                <td>{test.cakeThicknessHthp}</td>
                                                <td>{test.retortContentSolids}</td>
                                                <td>{test.retortContentOil}</td>
                                                <td>{test.retortContentWater}</td>
                                                <td>{test.lowGravityPcnt}</td>
                                                <td>{test.calcium}</td>
                                                <td>???</td>
                                                <td>{test.versenate}</td>
                                                <td>{test.limeContent}</td>
                                                <td>{test.oilWaterRatioTo}</td>
                                                <td>{test.electricalStability}</td>
                                                <td>{test.dailyTotal}</td>
                                                <td>{test.cumulativeTotal}</td>
                                            </tr>
                                            {test.recapRemarks !== '' && test.recapRemarks !== null &&
                                                <tr>
                                                    <td colSpan={28} style={{'textAlign': 'left'}}>{test.recapRemarks}</td>
                                                </tr>
                                            }
                                        </React.Fragment>
                                    )
                                }
                            </tbody>
                        </Table>
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default RecapReportTests;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/RecapReport/RecapReportTests/RecapReportTests.tsx